import moment from 'moment'
import { encRSA } from "./encryptPublic";
import { sha256 } from "js-sha256";
export default {
    // 加密(签名和时间放在data里面)
    // data 参数 
    encrypt(data,keyToken,pbk){
        let now = moment().format("YYYY-MM-DD HH:mm:ss");
        data = Object.assign(data,{sign:'',time:now})
        let arrays = Object.keys(data).filter(si=>si!='sign'),obj = {},str = ``;
        arrays = arrays.sort()
        arrays.forEach(si=>{
            if(si == 'weChatToken'){
            obj[si] = (data[si] || 'null')
            }
            else
            {
            obj[si] = data[si]
            }
        })
        for(let item in obj){str+=`${item}:${obj[item]},`}
        // console.log('obj',obj)
        data['sign'] = sha256(str.substring(0,str.length - 1))
        // console.log('data',data)
        // console.log('pbk',pbk)
        return {data:encRSA(JSON.stringify(data),pbk),key:keyToken}
    }
}
